import React from 'react'
import { Pane, Tooltip } from 'evergreen-ui'
import { Link } from 'react-router-dom'

export default ({ icon, title, active, to }) => <Tooltip content={title}>
    <Link to={to}>
        <Pane borderBottom={active ? '2px solid white' : '2px solid transparent'} width='50px' height='100%' display='flex' alignItems='center' justifyContent='center' color='white'>
            <i data-eva={icon} data-eva-fill="white" />
        </Pane></Link></Tooltip>